import { Component, inject } from '@angular/core';
import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { B2bProgramType, b2bProgramTypeList } from '../../../shared/models/b2b-program-type';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonModule } from '@ui/form/button/button.module';
import { DialogActions } from '@ui/dialog-v2/dialog-actions/dialog-actions';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-select-program-type-dialog',
    imports: [ButtonModule, DialogActions, TranslatePipe],
    templateUrl: './select-program-type-dialog.component.html',
    styleUrl: './select-program-type-dialog.component.scss',
    host: {
        class: 'select-program-type-dialog',
    },
})
export class SelectProgramTypeDialogComponent {
    public readonly dialogRef: MatDialogRef<SelectProgramTypeDialogComponent> = inject(MatDialogRef);

    public readonly b2bProgramTypeList: AbstractListModel[] = b2bProgramTypeList;
    public b2bProgramType: B2bProgramType = B2bProgramType.SingleProduct;

    public selectB2bProgramType(b2bProgramType: number | string): void {
        this.b2bProgramType = b2bProgramType as B2bProgramType;
    }

    public confirmB2bProgramTypeSelect(): void {
        this.dialogRef.close(this.b2bProgramType);
    }
}
